module.exports = __webpack_public_path__ + "static/plan_your_day_desktop-25c5781b519a773fa5ae4afdaeddff63.png";